import { AutocompleteProvider } from "../../types/enums";

const FAILURES_BEFORE_SKIP = 2;
const SKIP_DURATION_MS = 60_000;

type ProviderState = {
    failureCount: number,
    skipUntil: number
};

/**
 * Parks a provider that keeps failing so a dead primary isn't re-tried on every keystroke —
 * each attempt would otherwise cost the caller its full timeout before the failover runs.
 * State is per page load; a parked provider is probed again once the window passes.
 */
export class GeoSearchProviderHealth {
    private readonly _states = new Map<AutocompleteProvider, ProviderState>();

    public isParked(providerId: AutocompleteProvider): boolean {
        const state = this._states.get(providerId);
        if (!state)
            return false;

        return state.skipUntil > Date.now();
    }

    public recordSuccess(providerId: AutocompleteProvider): void {
        this._states.delete(providerId);
    }

    public recordFailure(providerId: AutocompleteProvider): void {
        const state = this._states.get(providerId) ?? { failureCount: 0, skipUntil: 0 };
        state.failureCount++;

        if (state.failureCount >= FAILURES_BEFORE_SKIP) {
            state.skipUntil = Date.now() + SKIP_DURATION_MS;
            state.failureCount = 0;
        }

        this._states.set(providerId, state);
    }
}
